import { render, staticRenderFns } from "./LocaleChanger.vue?vue&type=template&id=03f86058&scoped=true&"
import script from "./LocaleChanger.vue?vue&type=script&lang=js&"
export * from "./LocaleChanger.vue?vue&type=script&lang=js&"
import style0 from "./LocaleChanger.vue?vue&type=style&index=0&id=03f86058&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f86058",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VIcon,VSelect})
